// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wADHR4IbHoHaExt2R4d6 {
  margin: 0 auto;
}

.C52TZkU_W1rLN2PZE6Zq {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}

.uxZy492L2nAFlOsTZ3AX {
  align-items: center;
}
@media screen and (min-width: 800px) {
  .uxZy492L2nAFlOsTZ3AX {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./packages/aiand-qa/frontend/src/pages/notFound/NotFound.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;AAAE;EAFF;IAGI,aAAA;EAGF;AACF","sourceRoot":""}]);
// Exports
export var section = `wADHR4IbHoHaExt2R4d6`;
export var column = `C52TZkU_W1rLN2PZE6Zq`;
export var columns = `uxZy492L2nAFlOsTZ3AX`;
export default ___CSS_LOADER_EXPORT___;
